import { Dispatch } from 'redux';
import { riskRuleApi } from '../../apis';
import { showFeedback } from '../../feedback/feedbackReducer';
import { RiskRulesModalFormValues } from './RiskRulesModal';
import { parseErrorMessage } from '../../common/errors/helpers';

export const saveRiskRule = (apiRiskRule: RiskRulesModalFormValues) => async (dispatch: Dispatch) => {
  const rule = await riskRuleApi.addRiskRule({ apiRiskRule });
  dispatch(
    showFeedback({
      message: `Rule #${rule.id} added!`,
      success: true,
    })
  );
};

export const processError = (e: unknown) => async (dispatch: Dispatch) => {
  const message = await parseErrorMessage(e);
  dispatch(
    showFeedback({
      message,
      success: false,
    })
  );
};
